<div class="document-viewer-container">

    <mycampapp-privacy *ngIf="documentType === DocumentType.PrivacyPolicy"></mycampapp-privacy>
    <mycampapp-terms *ngIf="documentType === DocumentType.TermsOfService"></mycampapp-terms>
    <mycampapp-faq *ngIf="documentType === DocumentType.FAQ"></mycampapp-faq>

</div>
